import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { postCrearNotificacion } from "../../../api/ApiService";
import { useNavigate } from "react-router-dom";

function AddNotificacionPage() {
    const [cargando, setCargando] = useState(false);
    const [titulo, setTitulo] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [tipo] = useState("generica");
    const [tipoId] = useState(0);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const navigate = useNavigate();

    useEffect(() => {
        if (stateToken?.access_token) {
            setCargando(true);
        }
    }, [stateToken]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleCancelar = () => {
        window.history.back();
    };

    const validateFields = () => {
        if (!titulo.trim()) {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo titulo es obligatorio");
            return false;
        }

        if (!descripcion.trim()) {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo descripcion es obligatorio");
            return false;
        }

        return true;
    };

    const handleCrearNotificacionApi = (body) => {
        postCrearNotificacion(stateToken?.access_token, body)
            .then(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("success");
                setMensaje("Guardado con exito");

                setTimeout(() => {
                    navigate("/app/admin/notificaciones");
                }, 1500);
            })
            .catch((error) => {
                console.log("error-postCrearNotificacion", error);
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al guardar la notificacion");
            });
    };

    const handleGuardar = () => {
        if (!validateFields()) {
            return;
        }

        const body = {
            titulo: titulo.trim(),
            descripcion: descripcion.trim(),
            // tipo: tipo,
            // tipo_id: tipoId,
            tipo: "generica",
            tipo_id: 0,
        };

        // Objeto enviado al endpoint /notificaciones/store.
        setLoadingGuardar(true);
        handleCrearNotificacionApi(body);
    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="mx-auto max-w-5xl">
                    <div className="mb-6">
                        <h1 className="mb-1 text-2xl font-bold text-gray-800">Crear Notificación</h1>
                        <p className="text-sm text-gray-500">
                            Completa el contenido principal de la notificación. El tipo se enviará como generica.
                        </p>
                    </div>

                    {cargando ? (
                        <div className="rounded-xl bg-white shadow-xl overflow-hidden">
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleGuardar();
                                }}
                            >
                                <div className="p-6 grid grid-cols-1 gap-6">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Título</label>
                                        <input
                                            type="text"
                                            value={titulo}
                                            onChange={(e) => setTitulo(e.target.value)}
                                            placeholder="Ej: ‼️Primer martes con Itaú - MAÑANA‼️"
                                            className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm outline-none transition focus:ring-2 focus:ring-blue-500"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Descripción</label>
                                        <textarea
                                            value={descripcion}
                                            onChange={(e) => setDescripcion(e.target.value)}
                                            rows={7}
                                            placeholder="Escribe el mensaje completo de la notificación"
                                            className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm outline-none transition focus:ring-2 focus:ring-blue-500"
                                            required
                                        />
                                    </div>

                                    {/* <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Tipo</label>
                                            <input
                                                type="text"
                                                value={tipo}
                                                disabled
                                                className="w-full rounded-lg border border-gray-300 bg-gray-100 px-3 py-2.5 text-sm text-gray-700"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Tipo ID</label>
                                            <input
                                                type="text"
                                                value={tipoId}
                                                disabled
                                                className="w-full rounded-lg border border-gray-300 bg-gray-100 px-3 py-2.5 text-sm text-gray-700"
                                            />
                                        </div>
                                    </div> */}
                                </div>

                                <div className="flex justify-start gap-3 border-t border-gray-200 p-6">
                                    <button
                                        type="submit"
                                        className="rounded-lg bg-[#104063] px-6 py-2 font-medium text-white transition-colors hover:bg-[#0d3553]"
                                        disabled={loadingGuardar}
                                    >
                                        {loadingGuardar ? "Guardando..." : "Guardar"}
                                    </button>

                                    <button
                                        type="button"
                                        onClick={handleCancelar}
                                        className="rounded-lg bg-gray-100 px-6 py-2 font-medium text-gray-700 transition-colors hover:bg-gray-200"
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled">
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AddNotificacionPage;